
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "ResponsiveSkinskin1758278258",
      {"classes":{"root":"ResponsiveSkinskin1758278258__root"},"vars":{"focus-ring-box-shadow":"--ResponsiveSkinskin1758278258-focus-ring-box-shadow"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  